import React, { useMemo } from "react";
import CenteredModal from "./CenteredModal";
import { CalendarIcon, CheckIcon, ClockIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";
import { ExclamationIcon } from "@heroicons/react/solid";
import RequestsModel from "../../api/models/RequestsModel";
import moment from "moment";
import ApiDateParser from "../../helpers/parsers/apiDateParser";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";
type SessionModalApologizeProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
  request?: RequestsModel | null;
};
export default function SessionModalApologize(
  props: SessionModalApologizeProps
) {
  const { open, setOpen, request } = props;
  const LocalBasePath = "page.tutor.dashboard.requests";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const renderStatus = useMemo(() => {
    if (request?.status === "rejected")
      return (
        <span className="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-red-600 bg-transparent border border-red-600 flex-nowrap rounded-xl ">
          <ExclamationIcon className="flex-shrink-0 w-4 h-4 " />
          {t("haveRejected")}
        </span>
      );
    if (request?.status === "approved")
      return (
        <span className="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-green-500 bg-transparent border border-green-500 flex-nowrap rounded-xl ">
          <ExclamationIcon className="flex-shrink-0 w-4 h-4 " />
          {t("haveAccepted")}
        </span>
      );
    else
      return (
        <span className="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-yellow-600 bg-transparent border border-yellow-600 flex-nowrap rounded-xl ">
          <ExclamationIcon className="flex-shrink-0 w-4 h-4 " />
          {t("havePending")}
        </span>
      );
  }, [request]);
  return (
    <CenteredModal open={open} setOpen={setOpen}>
      <div className="flex flex-col w-[270px] sm:w-[400px] md:min-w-[600px]  md:max-w-4xl gap-2 pb-4">
        <div className="flex items-center justify-end w-full">
          <p className="text-sm text-gray-400">
            {" "}
            {moment(request?.createdAt).fromNow(true)}
          </p>
        </div>
        <div className="flex flex-col justify-between w-full gap-3 sm:gap-1 sm:flex-row">
          <div className="relative flex items-center gap-1 space-x-3">
            <div className="flex-shrink-0">
              <UserProfilePictureAvatar
                className="w-10 h-10 rounded-full"
                profilePictureUrl={request?.user?.profile_picture_url}
                alt="avatar"
              />
            </div>
            <div className="flex-1 min-w-0">
              <a className="focus:outline-none">
                <span className="absolute inset-0" aria-hidden="true" />
                <p className="text-lg font-semibold text-gray-500">
                  {request?.user?.fullNameWithoutMiddle}
                </p>
              </a>
            </div>
          </div>
          <div className="flex flex-row items-center gap-3">{renderStatus}</div>
        </div>
        <div className="flex flex-col w-full gap-2">
          <div className="flex flex-row justify-between w-full ">
            <p className="text-xl font-medium leading-8 text-gray-700">
              {t("session")} # {request?.sessionNumber}
            </p>
          </div>
          <div className="flex flex-row items-center w-full gap-4 ">
            <p className="flex  flex-row gap-[6px] text-gray-400 text-sm font-medium ">
              <CalendarIcon className="w-5 h-5" />
              {moment(request?.date).format("dddd M/D")}
            </p>
            <p className="flex  flex-row gap-[6px] text-gray-400 text-sm font-medium ">
              <ClockIcon className="w-5 h-5" />
              {ApiDateParser.parse(request?.scheduleSlot?.start_time).format(
                "hh:mm A"
              )}
            </p>
          </div>
          <div className="flex flex-col w-full gap-1">
            <h4 className="text-sm font-medium text-gray-600">
              {t("reasonShowDesc")}
            </h4>
            <p className="text-sm font-normal text-gray-400">
              {request?.cancellationReason}
            </p>
          </div>
        </div>
      </div>
    </CenteredModal>
  );
}
